import { ForecastMethods } from '@models/stable-balance/forecast-settings';

export const getForecastMethodName = (fm: ForecastMethods): string => {
  return typeof fm === 'string' ? `${fm}`.trim() : ForecastMethods[fm];
};
